import {List} from 'immutable';
import * as types from '../types/product';
import * as api from '../constants/';
import axios from 'axios';

function requestProductsCategories() {
  return {
    type: types.PRODUCT_CATEGORY_REQUEST,
  };
}

function requestProductsTypes() {
  return {
    type: types.PRODUCT_TYPE_REQUEST,
  };
}

function requestPizzaSauces() {
  return {
    type: types.PIZZA_SAUCE_REQUEST,
  };
}

function requestPizzaCategories() {
  return {
    type: types.PIZZA_CATEGORY_REQUEST,
  };
}

function receivePizzaSauces(data) {
  return {
    type: types.PIZZA_SAUCE_FETCHED,
    data: data,
  };
}

function receivePizzaCategories(data) {
  return {
    type: types.PIZZA_CATEGORY_FETCHED,
    data: data,
  };
}

function receiveProductCategories(data) {
  return {
    type: types.PRODUCT_CATEGORY_FETCHED,
    data: data,
  };
}

function receiveProductTypes(data) {
  return {
    type: types.PRODUCT_TYPE_FETCHED,
    data: data,
  };
}

function receivePizzaIngredients(data) {
  return {
    type: types.INGREDIENT_FETCHED,
    data: data,
  };
}

function fetchProductCategories() {
  return dispatch => {
    dispatch(requestProductsCategories());
    return axios.get(api.PRODUCT_CATEGORY_URL)
      .then(response => dispatch(receiveProductCategories(List(response.data))));
  };
}

function fetchProductTypes() {
  return dispatch => {
    dispatch(requestProductsTypes());
    return axios.get(api.PRODUCT_TYPE_URL)
      .then(response => dispatch(receiveProductTypes(List(response.data))));
  };
}

function fetchPizzaSauces() {
  return dispatch => {
    dispatch(requestPizzaSauces());
    return axios.get(api.PIZZA_SAUCE_URL)
      .then(response => dispatch(receivePizzaSauces(List(response.data))));
  };
}

function fetchPizzaCategories() {
  return dispatch => {
    dispatch(requestPizzaCategories());
    return axios.get(api.PIZZA_CATEGORY_URL)
      .then(response => dispatch(receivePizzaCategories(List(response.data))));
  };
}

function fetchPizzaIngredients() {
  return dispatch => {
    return axios.get(api.INGREDIENT_URL)
      .then(response => dispatch(receivePizzaIngredients(List(response.data))));
  };
}

export function getProductCategories() {
  return dispatch => {
    return dispatch(fetchProductCategories());
  };
}

export function getProductTypes() {
  return dispatch => {
    return dispatch(fetchProductTypes());
  };
}

export function selectType(id) {
  return dispatch => {
    dispatch({
      type: types.PRODUCT_TYPE_FILTER,
      data: id,
    });
  };
}

export function getPizzaSauces() {
  return dispatch => {
    return dispatch(fetchPizzaSauces());
  };
}

export function getPizzaCategories() {
  return dispatch => {
    return dispatch(fetchPizzaCategories());
  };
}

export function getPizzaIngredients() {
  return dispatch => {
    return dispatch(fetchPizzaIngredients());
  };
}

export function selectCategory(id) {
  return dispatch => {
    dispatch({
      type: types.PRODUCT_CATEGORY_FILTER,
      data: id,
    });
  };
}


// WEBPACK FOOTER //
// ./src/actions/productActions.js